import { PlannedOccurrence } from 'shared/types/habit-schedule';
import { Timestamp } from 'shared/types/timestamp';

export enum MetaViewOptions {
  Settings = 'settings',
  Statistics = 'statistics',
  Upcoming = 'upcoming',
}

export type UpcomingWeek = {
  date: Timestamp;
  days: {
    date: Timestamp;
    entry?: PlannedOccurrence;
  }[];
};
